import Vue from 'vue'
import App from './App'
import { createRouter } from './router'
import stores from './stores'
// import user from './stores/modules/user'
import component from './components'
import JElementUI from '@jd/element-ui'
// import 'element-ui/lib/theme-default/index.css'
import './filters'
import i18n from './i18n'
import '@/assets/css/comm.css'
import '@/assets/css/common.css'
import '@/assets/css/ui.css'
import '@/assets/css/user.css'

Vue.config.productionTip = process.env.NODE_ENV === 'development'

// Vue.prototype.userPin = user.userPin
// Vue.prototype.adminPin = user.adminPin // 子账号，即当前登录的账号

Vue.use(component)
Vue.use(JElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})


async function start(options = {}) {
  new Vue({
    el: '#app',
    store: stores,
    router: createRouter(options.basePath || ''),
    components: { App },
    template: '<App/>',
    i18n
  })
}

if (!window.__POWERED_BY_QIANKUN__) {
  start()
} else {
  // eslint-disable-next-line
  if(process.env.NODE_ENV==='production'){
    // eslint-disable-next-line
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ + 'public/'
  } else {
    // eslint-disable-next-line
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
  }
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function bootstrap() {}
export async function mount({ paths }) {
  debugger
  return start({
    basePath: paths[0]
  })
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {}
/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props) {
  console.log('update props', props)
}
